module.exports = __webpack_public_path__ + "img/IOTalent.7da9b1c1.png";